const mode = window.location.host.includes("localhost")
  ? "DEV"
  : window.location.host.includes("dev")
    ? "DEV"
    : "PROD";

var COINMARKET_URL = "https://pro-api.coinmarketcap.com/",
  TIDIO_Key = "bv8h8nzd82aymfxwv8mv9z07z50ehurk.js",
  WEBSITE_URL,
  API_URL,
  ADMIN_URL,
  SOCKET_URL,
  ORDER_API_URL;

if (mode === "PROD") {
  WEBSITE_URL = "https://amexa.exchange/";
  API_URL = "https://apis.amexa.exchange/";
  ADMIN_URL = "https://apis.amexa.exchange/";
  SOCKET_URL = "https://apis.amexa.exchange";
  ORDER_API_URL = "https://apis.amexa.exchange/";
} else if (mode === "DEV") {
  WEBSITE_URL = "https://dev-amexa.exchange/";
  API_URL = "https://dev-backend.amexa.exchange/";
  ADMIN_URL = "https://dev-backend.amexa.exchange/";
  SOCKET_URL = "https://dev-backend.amexa.exchange";
  ORDER_API_URL = "https://dev-backend.amexa.exchange/";
} else {
  WEBSITE_URL = "http://localhost:3000/";
  API_URL = "http://localhost:8000/";
  ADMIN_URL = "http://localhost:8000/";
  SOCKET_URL = "http://localhost:8000";
  ORDER_API_URL = "http://localhost:8000/";
}

export {
  WEBSITE_URL,
  API_URL,
  ADMIN_URL,
  SOCKET_URL,
  ORDER_API_URL,
  COINMARKET_URL,
  TIDIO_Key,
};
